import clsx from 'clsx';

import { Image } from '@repo/ui/Image';

type Props = { lineItem: 'separator' } | { lineItem: 'textIcon'; item: { icon: string; text: string } };

export const ValuePropLineItem: React.FC<Props> = (props) => (
  <div className={clsx('grid grid-cols-[auto_1fr] items-center gap-4', { '-mb-1': props.lineItem === 'separator' })}>
    {props.lineItem === 'separator' ? (
      <>
        <div className="c-fs-overline">OR</div>
        <div className="w-full border-t border-for-neu-tie3" />
      </>
    ) : (
      <>
        <Image src={props.item.icon} alt="" width={32} height={32} className="block" />
        <div className="c-fs-body2 text-tex-def-tie2">{props.item.text}</div>
      </>
    )}
  </div>
);
